'use client';

import { useQuery } from '@tanstack/react-query';
import { SITECONFIG_QUERIES } from '../../infrastructure/siteconfig/utils/queries';

export const useSiteconfigService = () => {
  const useGetShippingPolicies = () => {
    return useQuery(SITECONFIG_QUERIES.getShippingPolicies());
  };

  return {
    useGetShippingPolicies,
  };
};
